import { FullEvent, formatLocalDateTimeHourAndMinutes, formatLocalDateTimeShort, parseDate } from 'model';
import { PostTypeViewProps } from './types.js';
import { PostTitle } from '../PostTitle.js';
import { PostHeader } from '../PostHeader.js';
import { IonRouterLink } from '@ionic/react';
import { mapurl } from '../../util/mapurl.js';
import { IconLocation, IconTime } from '../QuirkIcons/index.js';
// eslint-disable-next-line css-modules/no-unused-class
import sharedStyles from '../../styles/Shared.module.css';
// eslint-disable-next-line css-modules/no-unused-class
import postStyles from '../../styles/posts.module.css';
import { filterInlineImages } from '../../util/filterInlineImages.js';
import { BigImageContainer } from '../BigImageContainer.js';
import { LinkPreviewComponent } from '../LinkPreviewComponent.js';
import { PostContentsSummary } from '../PostContentsSummary.js';

export function EventView({ post, detail, preview, expanded, testId }: PostTypeViewProps<FullEvent>) {
	return (
		<>
			<PostHeader post={post} postDate={post.eventDate} />
			<PostTitle postId={post._id}>{post.title}</PostTitle>
			<div
				className={sharedStyles.dateContainer}
				style={{ marginBottom: '5px' }}
				data-testid={`EventLocation-${post._id}`}
			>
				<IonRouterLink target="_blank" href={mapurl(post.location)}>
					<div className={postStyles.iconBullet}>
						<span>
							<IconLocation size="small" />
						</span>
						<div>{post.location}</div>
					</div>
				</IonRouterLink>
			</div>
			<div
				className={sharedStyles.dateContainer}
				style={{ marginBottom: '20px' }}
				data-testid={`EventTime-${post._id}`}
			>
				<div className={postStyles.iconBullet}>
					<span>
						<IconTime size="small" />
					</span>
				</div>
				<div className={sharedStyles.time} data-testid={`EventTime-${post._id}`}>
					{formatLocalDateTimeShort(post.eventDate)}{' '}
					{post.eventEndDate &&
						(parseDate(post.eventDate).hasSame(parseDate(post.eventEndDate), 'day')
							? ' - ' + formatLocalDateTimeHourAndMinutes(post.eventEndDate)
							: ' - ' + formatLocalDateTimeShort(post.eventEndDate))}
				</div>
			</div>
			{!preview && (
				<div className={postStyles.postBody} data-testid={testId}>
					{detail && post.images.length > 0 && (
						<BigImageContainer post={post} images={filterInlineImages(post.contents, post.images)} />
					)}
					<PostContentsSummary post={post} allowExpand={detail} expanded={expanded} />
					<LinkPreviewComponent linkPreview={post.linkPreview} />
					{!detail && post.images.length > 0 && (
						<BigImageContainer post={post} images={filterInlineImages(post.contents, post.images)} />
					)}
				</div>
			)}
		</>
	);
}
